import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Card, CardBody, Col, FormFeedback, Input, Label, Row, Table } from "reactstrap";
import * as Yup from "yup";
import "./style.scss";

import ToastDialog from "components/Common/ToastDialog";

//Import Breadcrumb
import { getDropDownList } from "http/fundLync/dropdown.helper";
import {
  addShareholding,
  editShareholding,
  getShareholdingList,
} from "http/fundLync/entityAndAddress.helper";
import { formatDateString, formatDateString1 } from "./borrowingProfile";
import { decryptedValue, isPermission } from "common/utility";
import { getOneSystemConfiguration } from "http/UAM/systemConfig.helper";
import { callGetOneScormeResponse } from "http/cin/cin";
import { callGetProbeCreditRatings } from "http/fundLync/entityDocuments.helper";

const TableRow = ({
  onDelete,
  index,
  validation,
  percentageholdingValue,
}) => {
  const [shareholderType, setShareholderType] = useState([]);

  useEffect(() => {
    getDropDownList({ dropdownName: "shareholder" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "shareholder")
            ?.dropdownValues || [];
        setShareholderType(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`shareholderList.${index}.${field}`, value);
    if (field == "percentageHolding") {
      percentageholdingValue(+value);
    }
  };

  return (
    <tr>
      <td>
        <Input
          type="text"
          placeholder="Enter Shareholder Name"
          name={`shareholder[${index}].shareholderName`}
          id={`shareholder[${index}].shareholderName`}
          value={validation.values.shareholderList[index].sharehAolderName}
          onChange={(event) => {
            handleInputChange(index, "shareholderName", event.target.value);
          }}
        />
      </td>
      <td style={{ width: "30%" }}>
        <Select
          options={shareholderType.map((option, index) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }))}
          className={`${
            validation.touched.shareholderList?.[index]?.shareholderType &&
            validation.errors.shareholderList?.[index]?.shareholderType
              ? "is-invalid"
              : ""
          }`}
          name={`shareholder[${index}].shareholderType`}
          id={`shareholder[${index}].shareholderType`}
          onChange={(selectedOption) => {
            handleInputChange(index, "shareholderType", selectedOption.value);
          }}
          value={setshareholdingType(
            shareholderType,
            validation.values.shareholderList[index].shareholderType
          )}
        />
        {validation.touched.shareholderList?.[index]?.shareholderType &&
          validation.errors.shareholderList?.[index]?.shareholderType && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.shareholderType}
            </FormFeedback>
          )}
      </td>
      <td>
        <Input
          type="number"
          placeholder="Enter Shareholding Percentage"
          name={`shareholder[${index}].percentageHolding`}
          id={`shareholder[${index}].percentageHolding`}
          value={validation.values.shareholderList[index].percentageHolding}
          onChange={(event) => {
            handleInputChange(index, "percentageHolding", event.target.value);
          }}
          invalid={
            validation.touched?.shareholderList?.[index]?.percentageHolding &&
            validation.errors?.shareholderList?.[index]?.percentageHolding
              ? true
              : false
          }
        />

        {validation.touched.shareholderList?.[index]?.percentageHolding &&
          validation.errors.shareholderList?.[index]?.percentageHolding && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.percentageHolding}
            </FormFeedback>
          )}
      </td>
      <td>
        {validation.values?.shareholderList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );

  function setshareholdingType(data, shareholdingType) {
    if (shareholdingType) {
      for (const item of data) {
        if (item.dropdownValue === shareholdingType) {
          const value = {
            label: `${item.displayName}`,
            value: shareholdingType,
          };
          return value;
        }
      }
    }
  }
};

const ShareholdingPatterns = (props) => {
  document.title = "Shareholding Patterns | FundLync";
  const currentDate = new Date().toISOString().split("T")[0];

  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  

  const [rows, setRows] = useState([
    {
      shareholderName: "",
      shareholderType: "",
      percentageHolding: "",
    },
  ]);
  const [shareholdingList, setShareholdingList] = useState([]);
  const [shareholderList, setShareholderList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [percentageholdingValue, setPercentageholdingValue] = useState(0);
  const [isAddShareholdingPermission, setIsAddShareholdingPermission] = useState(false);
  const [isEditShareholdingPermission, setIsEditShareholdingPermission] = useState(false);
  const [showLoadingText, setShowLoadingText] = useState(false);
  const [editMode, setEditMode] = useState(false)
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [dataType, setDataType] = useState('STANDALONE');
  const [directorShareholdings, setDirectorShareholdings] = useState([])
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])

  useEffect(() => {
    if(entityId){
    getShareholdingList({ entityId })
      .then((response) => {
        const allshareholdings = response.data?.data || [];
        if (allshareholdings.length > 0) {
          const formatedDate = formatDateString1(
            allshareholdings[0].shareholdingAsOf
          );
          allshareholdings[0].shareholdingAsOf = formatedDate;
          setShareholdingList(allshareholdings);
          setShareholderList(response.data?.data[0].shareholderList)
          setRows(allshareholdings[0].shareholderList);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
    getOneSystemConfiguration({ configKey: "SHAREHOLDING_FROM_CIN" })
      .then((response) => {
        if (response?.data[0]?.configValue == "yes") {
          callGetOneScormeResponse({ entityId })
          .then((response) => {
            if(response.status){
              if (
                response?.data?.length > 0 &&
                response?.data[0].statusMsg == "submitted" && 
                response?.data[0]?.type== "mca"
              ) {
                setShowLoadingText(true);
              } else if (
                response?.data[0]?.statusMsg == "success" &&
                response?.data[0]?.responseJson != null &&
                response?.data[0]?.derivedJson == null &&
                response?.data[0]?.type== "mca"
              ) {
                setShowLoadingText(true);
              } else if (
                response?.data[0]?.statusMsg == "success" &&
                response?.data[0]?.derivedJson != null && 
                response?.data[0]?.type== "mca"
              ) {
                setShowLoadingText(false);
            }
              }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  
    checkPermissions();
  }, [entityId]);

  const toggleEditMode = () => {
    setEditMode(!editMode);
  }

  const checkPermissions = async () => {
    const addShareholdingpermission = await isPermission(
      "shareholding",
      "create_permission"
    );
    const editShareholdingpermission = await isPermission(
      "shareholding",
      "edit_permission"
    );

    setIsAddShareholdingPermission(addShareholdingpermission);
    setIsEditShareholdingPermission(editShareholdingpermission);
  };

  const handleDelete = (rowIndex) => {
    validation.values.shareholderList.splice(rowIndex, 1);
    setPercentageholdingValue(0);
    validation.validateForm();
  };

  const handleItemSelect = (data, value) => {
    data.type = value;
    validation.setFieldValue("type", value);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      shareholdingAsOf: shareholdingList[0]?.shareholdingAsOf || "",
      shareholderList: rows || [
        {
          shareholderName: "",
          shareholderType: "",
          percentageHolding: "",
        },
      ],
    },
    validationSchema: Yup.object({
      shareholdingAsOf: Yup.date().required("Shareholding as of is Required"),
      shareholderList: Yup.array().of(
        Yup.object({
          shareholderType: Yup.string().required(
            "Shareholder Type is required"
          ),
          percentageHolding: Yup.number()
            .required("Percentage Holding is required")
            .min(0, "Percentage Holding cannot be less than 0"),
        })
      ),
    }),
    onSubmit: (values) => {
      let totalShareholding = 0;
      values.shareholderList.forEach((elem) => {
        totalShareholding += +elem.percentageHolding;
        totalShareholding = Math.round(totalShareholding * 100) / 100;
      });
      if (totalShareholding > 100) {
        setToastInfo({
          message: "%Holding Shouldn't be greater than 100",
          showToast: true,
          role: "error",
        });
        return;
      }
      if (totalShareholding < 100) {
        setToastInfo({
          message: "%Holding Shouldn't be less than 100",
          showToast: true,
          role: "error",
        });
        return;
      }
      let shareholdingPatternObj = {
        shareholdingAsOf: values.shareholdingAsOf,
        totalShareholding,
        entityId,
        shareholderList: values.shareholderList,
      };

      if (shareholdingList.length == 0) {
        addShareholding(shareholdingPatternObj)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Shareholding Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave()
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        shareholdingPatternObj.id = shareholdingList[0].id;
        editShareholding(shareholdingPatternObj)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Shareholding Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave()
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  });

  const onChangePercentageValue = (value) => {
    setPercentageholdingValue(percentageholdingValue + value);
  };
  let totalValue = 0;
  for (let value of validation.values.shareholderList) {
    totalValue += +value.percentageHolding;
    totalValue = Math.round(totalValue * 100) / 100;
  }
  const formatLenderName = (name) => {
    if (!name) return '-';
  
    let formattedName = name
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  
    formattedName = formattedName.replace(/\(([^)]+)\)/g, (match, p1) => {
      let transformedContent = p1
        .split(' ')
        .map(word => {
          if (word.toLowerCase() === 'nris') {
            return "NRI's";
          }
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
      return `(${transformedContent})`;
    });
  
    return formattedName;
  };
  const callAfterSave = () => {
    getShareholdingList({ entityId })
      .then((response) => {
        setEditMode(false)
        const allshareholdings = response.data?.data || [];
        if (allshareholdings.length > 0) {
          const formatedDate = formatDateString1(
            allshareholdings[0].shareholdingAsOf
          );
          allshareholdings[0].shareholdingAsOf = formatedDate;
          setShareholdingList(allshareholdings);
          setShareholderList(response.data?.data[0].shareholderList)
          setRows(allshareholdings[0].shareholderList);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const handleToggle = (tab) => {
    setDataType(tab);
    if(tab==="CONSOLIDATED"){
      callGetProbeCreditRatings({entityId})
      .then((response) => {
        // setEditMode(false)
        const allshareholdings = response?.data?.director_shareholdings || [];
        if (allshareholdings.length > 0) {
          setDirectorShareholdings(response?.data?.director_shareholdings)
        }else{
          setDirectorShareholdings([])
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
    
  }
  return (

    <React.Fragment>
      {showLoadingText ? (
        <div>
          <p>Please wait system fetching Shareholding Data <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" /></p>
        </div>
      ) : (
        <div>
          <div className="toggle-switch-container">
            <div className="toggle-switch">
              <label className={`switch-label ${dataType === "STANDALONE" ? "active" : ""}`} onClick={() => handleToggle("STANDALONE")} tabIndex={0}>
                Shareholding Pattern
              </label>
              <label className={`switch-label ${dataType === "CONSOLIDATED" ? "active" : ""}`} onClick={() => handleToggle("CONSOLIDATED")} tabIndex={0}>
                Director Shareholding
              </label>
              <div className={`slider1 ${dataType === "CONSOLIDATED" ? "slide-right" : ""}`}></div>
            </div>
          </div>

          {dataType === "STANDALONE" ? (
            <>
              <div className="shareholdingDiv">
                <i className="fas fa-exclamation-circle draft"></i> Total shareholding should add up to 100%
              </div>

              <Card className="p-3">
                <div className="text-end mb-3">
                {validation.values.shareholderList.length > 0 && validation.values.shareholdingAsOf !== "" ? (
          <div className="text-end mb-3">
            <div style={{ cursor: "pointer" }}>
              {editMode ?
                <div className="text-sm-end">
                  <Button
                    type="button"
                    color="outline-success"
                    className="btn-rounded mb-2 me-2"
                    onClick={toggleEditMode}
                  >
                    close
                  </Button>
                </div>
                : <i className="mdi mdi-pencil font-size-16 text-success me-1" onClick={toggleEditMode}><span className="font-size-12">Edit</span></i>}
            </div>
          </div>
        ) : (
          <div className="text-end mb-3">
            <div style={{ cursor: "pointer" }}>
              {editMode ?
                <div className="text-sm-end">
                  <Button
                    type="button"
                    color="outline-success"
                    className="btn-rounded mb-2 me-2"
                    onClick={toggleEditMode} 
                  >
                    close
                  </Button>
                </div>
                : <div className="d-flex justify-content-end">
                  <Button
                    type="button"
                    style={{ backgroundColor: '#21aa47', borderColor: '#21aa47', color: '#fff' }}
                    className="mb-3 me-2"
                    onClick={toggleEditMode} 
                  >
                    <i className="fas fa-plus me-2"></i>
                    <span >
                      {" "}
                      Add Shareholder
                    </span>
                  </Button>
                </div>}
              </div>
            </div>
          )}
                </div>

                { editMode ? (
            <FormikProvider value={validation}>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  
                  return false;
                }}
              >
                <Row className="mt-4 mb-4">
                  <Col lg={3} className="me-5">
                    <Label
                      htmlFor="horizontal-email-Input"
                      className="col-sm-12 col-form-label"
                    >
                      Shareholding as of *
                    </Label>
                    <Input
                      type="date"
                      className="form-control"
                      name="shareholdingAsOf"
                      id="shareholdingAsOf"
                      max={currentDate}
                      value={validation.values.shareholdingAsOf || ""}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        !!(
                          validation.touched.shareholdingAsOf &&
                          validation.errors.shareholdingAsOf
                        )
                      }
                    />
                    {validation.touched.shareholdingAsOf &&
                    validation.errors.shareholdingAsOf ? (
                      <FormFeedback type="invalid">
                        {validation.errors.shareholdingAsOf}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col lg={2} sm={4}>
                    <Label
                      htmlFor="horizontal-email-Input"
                      className="col-sm-12 mt-2"
                    >
                      Total shareholding %
                    </Label>
                    <div className="shareholdingPercent">{totalValue}</div>
                  </Col>
                  <Col lg={2}></Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <div className="table-responsive react-table">
                      <Table
                        Table
                        striped
                        bordered
                        hover
                        style={{ width: "100%", backgroundColor: "white" }}
                      >
                        <thead>
                          <tr>
                            <th>Shareholder Name</th>
                            <th>Shareholder Type *</th>
                            <th>% Holding *</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <FieldArray
                            name="shareholderList"
                            render={(arrayHelpers) => (
                              <>
                                {validation.values.shareholderList.map(
                                  (shareholder, index) => (
                                    <TableRow
                                      key={shareholder.id}
                                      onDelete={handleDelete}
                                      onItemSelect={handleItemSelect}
                                      index={index}
                                      validation={validation}
                                      percentageholdingValue={
                                        onChangePercentageValue
                                      }
                                    />
                                  )
                                )}
                                <tr>
                                  <td colSpan={5}>
                                    <span
                                      className="text-success"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        arrayHelpers.push({
                                          shareholderName: "",
                                          shareholderType: "",
                                          percentageHolding: "",
                                        });
                                      }}
                                    >
                                      <i className="mdi mdi-plus me-1" /> Add
                                      Shareholder
                                    </span>
                                  </td>
                                </tr>
                              </>
                            )}
                          />
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {(shareholdingList.length == 0
                        ? isAddShareholdingPermission
                        : isEditShareholdingPermission) && (
                        <button type="submit" className="btn btn-success">
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
            ) : (
              <div> 
                {validation.values.shareholdingAsOf !== "" ?(
                  <Row>
                    <Col sm="6" className="mb-2">
                        <span className="font-size-16 entityDetailsValue">Shareholding As Of: {formatDateString(validation.values.shareholdingAsOf)}</span>{" "}
                    </Col>
                  </Row>
                ):(null)}
                {shareholderList.length !== 0  && validation.values.shareholdingAsOf !== "" ? (
                  shareholderList?.map((shareholder, index) => (
                    <React.Fragment key={index}>
                      <Row className="mt-3">
                        <Col sm="4" md="4" lg="4" className="mb-1">
                          <Label className="d-block entityDetails">Shareholder Name</Label>
                          <span className="mb-0 entityDetailsValue">{shareholder.shareholderName || '-'}</span>
                        </Col>
                        <Col sm="4" md="4" lg="4" className="mb-1">
                          <Label className="d-block entityDetails">Shareholder Type</Label>
                          <span className="mb-0 entityDetailsValue">{formatLenderName(shareholder.shareholderType) || '-'}</span>
                        </Col>
                        <Col sm="4" md="4" lg="4" className="mb-1">
                          <Label className="d-block entityDetails">Holding Percentage</Label>
                          <span className="mb-0 entityDetailsValue">
                            {shareholder.percentageHolding !== undefined && shareholder.percentageHolding !== null 
                              ? `${shareholder.percentageHolding}%` 
                              : '-'}
                          </span>
                        </Col>
                      </Row>
                      
                      <div style={{ marginTop: '1%', borderTop: '1px solid #d7d7d7' }}></div>
                    </React.Fragment>
                  ))
                  ) : (
                <div className="mt-5">
                  <p className="text-center">No Shareholding records available.</p>
                </div>
              )}
                  </div>
                )}
              </Card>
            </>
          ) : (
            <Card>
              <CardBody style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
       
          <div
            className="mt-2 mb-3 d-flex justify-content-even"
            style={{
              backgroundColor: "#F3F3F3",
              borderRadius: "10px",
              padding: "5px 10px",
              minWidth: "600px",
            }}
          >
            <Col>
              <Label className="d-block">Director Name</Label>
            </Col>
            <Col>
              <Label className="d-block">No. of Shares</Label>
            </Col>
            <Col>
              <Label className="d-block">% holding</Label>
            </Col>
          </div>

          {directorShareholdings.length > 0 ? (
            directorShareholdings.map((directorShareholding, index) => (
              <React.Fragment key={index}>
                <div
                  className="d-flex justify-content-even"
                  style={{ minWidth: "600px" }} // matches the header minWidth
                >
                  <Col>
                    <span className="mb-0 entityDetailsValue"> {directorShareholding.full_name || "-"}</span>
                  </Col>
                  <Col>
                    <span className="mb-0 entityDetailsValue"> {directorShareholding.no_of_shares || "-"}</span>
                  </Col>
                  <Col>
                  <span className="mb-0 entityDetailsValue">  {directorShareholding?.percentage_holding ? `${directorShareholding.percentage_holding}%` : "-"} </span>

                  </Col>
                </div>
                {directorShareholdings.length - 1 !== index && (
                  <div
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      borderTop: "1px solid #d7d7d7",
                      minWidth: "600px", // ensures the card can scroll when necessary
                    }}
                  ></div>
                )}
              </React.Fragment>
            ))
          ) : (
            <div className="mt-5">
              <p className="text-center">No director shareholding records available.</p>
            </div>
          )}
        </CardBody>
            </Card>
          )}
        </div>
      )}
      <ToastDialog message={toastInfo.message} showToast={toastInfo.showToast} role={toastInfo.role} onCloseFn={() => setToastInfo({ showToast: false })} />
    </React.Fragment>
  );
};


export default ShareholdingPatterns;
